import { render, staticRenderFns } from "./modal-one-btn.mpx?vue&type=template&id=c0bd67d2&isComponent&outputPath=components%2Fmodal-one-btn82939044%2Findex"
import script from "./modal-one-btn.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-one-btn82939044%2Findex"
export * from "./modal-one-btn.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-one-btn82939044%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports